import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/api';
import Button from '../../components/Button';
import Input from '../../components/Input';
import './Login.styles.scss';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = useCallback(async () => {
    try {
      const {
        data: { token },
      } = await api.login(username, password);
      localStorage.setItem('token', token);
      navigate('/home');
    } catch (e) {
      console.error(e);
    }
  }, [navigate, password, username]);

  return (
    <div className="data-room login-page">
      <div className="container-form">
        <p>Sign in</p>
        <Input
          label="Username"
          name="username"
          onChange={(ev) => setUsername(ev.target.value)}
        />
        <Input
          label="Password"
          name="password"
          type="password"
          onChange={(ev) => setPassword(ev.target.value)}
        />

        <Button onClick={handleLogin}>Sign in</Button>
      </div>
    </div>
  );
}

export default Login;
